import { render, staticRenderFns } from "./ModalBackDocuments.vue?vue&type=template&id=a3bbe9b4&scoped=true&"
import script from "./ModalBackDocuments.vue?vue&type=script&lang=ts&"
export * from "./ModalBackDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBackDocuments.vue?vue&type=style&index=0&id=a3bbe9b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bbe9b4",
  null
  
)

export default component.exports